import { render, staticRenderFns } from "./EloRanking.vue?vue&type=template&id=43befaa6&"
import script from "./EloRanking.vue?vue&type=script&lang=js&"
export * from "./EloRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports